(function() { window.GUID_dc1babc1_534f_41ec_b2d5_080aa621075c = { getGuid: function() { return "dc1babc1-534f-41ec-b2d5-080aa621075c"; } }; })();
var CS;
(function (CS) {
    var timeOutId = null;
    function Lag(lagTime, callback) {
        if (timeOutId != null) {
            clearTimeout(timeOutId);
        }
        timeOutId = setTimeout(callback, lagTime);
        return timeOutId;
    }
    CS.Lag = Lag;
    function LagLocal(localTimeOutId, lagTime, callback) {
        if (localTimeOutId != null) {
            clearTimeout(localTimeOutId);
        }
        localTimeOutId = window.setTimeout(callback, lagTime);
        return localTimeOutId;
    }
    CS.LagLocal = LagLocal;
    var lagNames = {}; //Dictionary<string, number>
    /**
     * Ajoute un délais à un call. Si vous l'appelez 2 fois avec le même 'uniqueName', seulement le 2e seras executé. Retourne le TimerHandle; peut être annulé avec 'clearTimeout(TimerHandle)'.
     * @param uniqueName
     * doit être unique à travers l'application. Utilisez quelque chose comme {Page}-{Method}-Autre
     * @param lagTime
     * temps en ms
     * @param callback
     * call ce callback après le lagTime
     */
    function LagV2(uniqueName, lagTime, callback) {
        if (!uniqueName) {
            console.error("uniqueName is required");
            return 0;
        }
        let localTimeOutId = lagNames[uniqueName];
        clearTimeout(localTimeOutId);
        localTimeOutId = window.setTimeout(callback, lagTime);
        lagNames[uniqueName] = localTimeOutId;
        return localTimeOutId;
    }
    CS.LagV2 = LagV2;
})(CS || (CS = {}));

//# sourceMappingURL=cs.lag.js.map
